import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=684776f8&"
import script from "./svg-icon.vue?vue&type=script&lang=ts&"
export * from "./svg-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684776f8')) {
      api.createRecord('684776f8', component.options)
    } else {
      api.reload('684776f8', component.options)
    }
    module.hot.accept("./svg-icon.vue?vue&type=template&id=684776f8&", function () {
      api.rerender('684776f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/svg-icon/svg-icon.vue"
export default component.exports